import React from "react";
import ReactDOM from "react-dom";
import {Members} from "../components/Members";

export const insertMembers = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="members"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<Members />, element);
  });
};
